import { Player } from "@lottiefiles/react-lottie-player";
import DownJson from "../../assets/down.json";

const DownView = () => {
  return (
    <Player
      src={DownJson}
      autoplay={true}
      style={{ height: "130px" }}
      loop
      speed={0.7}
    />
  );
};

export default DownView;
